<template>
  <div v-if="loading">
    <bar v-if="type === `bar`" :label="label" :is-small="isSmall" />
    <spinner
      v-else
      :label="label"
      :is-small="isSmall"
      :loading="loading"
      :is-full-screen="isFullScreen"
    />
  </div>
</template>

<script>
// Components - Bar & Spinner
import Bar from "./Bar";
import Spinner from "./Spinner";

export default {
  name: "LoadingIndicator",
  components: {
    Bar,
    Spinner,
  },
  props: {
    /**
     * @description
     * Flag to render the type of the Loading Indicator.
     * MDS supports Bar & Spinner.
     */
    type: {
      type: String,
      validator: (val) => ["bar", "spinner"].includes(val),
      default: "bar",
    },
    /**
     * @description
     * Provides Label to the Loading Indicator.
     * Applicable to Bar & normal spinner Loading Indicator.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Flag to render Loading Component with proper size
     * Applicable to Bar & normal spinner Loading Indicator.
     */
    isSmall: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Flag to render Loading Component
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Flag to render full screen Spinner Loading Component.
     * Applicable to full Screen spinner Loading Indicator.
     */
    isFullScreen: {
      type: Boolean,
      default: true,
    },
  },
};
</script>